import { useEffect, useState } from "react";
import { AddArm } from "./AddArm";
import { AddCondition } from "./AddCondition";
import { AddDrug } from "./AddDrug";
import { codelistUtils } from "../../utils/codelistUtils";

const useAddStudy = (props: any) => {
  const { register, unregister, errors, watch, setValue, isEdit, studyData,codelistData } =
    props;
  
  const [armTypes, setArmTypes] = useState([]);

  useEffect(() => {
    setArmTypes(
      codelistData?.find((item: any) => item.ARM_TYPE?.length > 0).ARM_TYPE
    );
  }, [codelistData]);

  const studyFields = [
    {
      name: "ind",
      label: "IND #",
      size: 4,
      inputType: "number",
      required: true,
      maxlength:6,
      type:'tel',
    },
    {
      name: "study_type",
      label: "Study Type",
      size: 4,
      inputType: "autocomplete",
      options: codelistUtils(codelistData,'STUDY_TYPE')?.codelistCodeValues,
      isOptionEqualToValue: true,
      required: true,
    },
    {
      name: "title",
      label: "Study Title",
      size: 12,
      inputType: "text",
      isMultiline: true,
      minRows: 1,
      maxRows: 3,
      required: true,
      maxlength: 600,
      wordCount: true,
    },
    {
      inputType: "customComponent",
      component: (
        <AddDrug
          register={register}
          unregister={unregister}
          errors={errors}
          watch={watch}
          setValue={setValue}
          isEdit={isEdit}
          studyData={studyData}
        />
      ),
    },
    {
      name: "study_phase",
      label: "Study Phase",
      size: 12,
      inputType: "autocomplete",
      options: codelistUtils(codelistData,'STUDY_PHASE')?.codelistCodeValues,
      required: true,
    },
    {
      name: "study_arms",
      inputType: "customComponent",
      component: (
        <AddArm
          register={register}
          unregister={unregister}
          errors={errors}
          armTypes={armTypes}
          watch={watch}
          setValue={setValue}
          studyData={studyData}
          isEdit={isEdit}
        />
      ),
    },
    {
      inputType: "customComponent",
      component: (
        <AddCondition
          register={register}
          unregister={unregister}
          errors={errors}
          watch={watch}
          setValue={setValue}
          isEdit={isEdit}
          studyData={studyData}
        />
      ),
    },
    {
      name: "start_date",
      label: "Start Date (Actual)",
      size: 4,
      inputType: "date",
      required: true,
    },
    {
      name: "primary_completion_date",
      label: "Primary Completion (Estimated)",
      size: 4,
      inputType: "date",
      required: true,
    },
    {
      name: "study_completion_date",
      label: "Study Completion (Estimated)",
      size: 4,
      inputType: "date",
      required: true,
    },
    {
      name: "enrollment",
      label: "Enrollment (Estimated)",
      size: 6,
      inputType: "number",
      required: true,
      maxlength:5,
      type:'tel',
    },
    {
      name: "study_status",
      label: "Status",
      size: 6,
      inputType: "autocomplete",
      options: codelistUtils(codelistData,'RECRUITMENT_STATUS')?.codelistCodeValues,
      isOptionEqualToValue: false,
      required: true,
    },
    {
      name: "brief_summary",
      label: "Brief Summary",
      size: 12,
      inputType: "text",
      isMultiline: true,
      minRows: 3,
      maxRows: 6,
      required: true,
      maxlength: 1500,
      wordCount: true,
    },
  ];

  const addStudyFields = [
    {
      name: "study_id",
      label: "Study ID",
      size: 4,
      inputType: "text",
      disabled: false,
      required: true,
      maxlength: 30,
    },
    ...studyFields,
  ];

  const editStudyFields = [
    {
      name: "study_id",
      label: "Study ID",
      size: 4,
      inputType: "text",
      disabled: true,
      required: true,
      maxlength: 30,
    },
    ...studyFields,
  ];

  return {
    addStudyFields,
    editStudyFields,
  };
};

export default useAddStudy;
